import isNumericDataType from 'scoreboard/components/is-numeric-data-type'

/**
 * Returns the default aggregation type for a widget that displays a dataset
 * value (eg shape, linear gauge, etc)
 *
 * @param {DatasetField} field
 * @return {AggregationType}
 */
function defaultDatasetValueWidgetAggregationType (field) {
	// #19394 non-numeric fields always use 'unique' aggregation
	return isNumericDataType(field.dataType) ? field.aggregationType : 'unique'
}

export default defaultDatasetValueWidgetAggregationType

defaultDatasetValueWidgetAggregationType.__filename__ = 'dashboards/widgets/default-dataset-value-widget-aggregation-type.js'
